import { useDraftOrders } from "../../../../hooks/api/v2/useDraftOrders";
import { useDraftOrderList } from "../../../../hooks/api/v2/draft-order/useDraftOrderList";
import { useUnifiedCheckoutBasketList } from "../../../../hooks/api/v2/unified-checkout-basket/useUnifiedCheckoutBaskets";
import { useUnifiedCheckoutDraftOrders } from "../../../unifiedCheckout/hooks/useUnifiedCheckoutDraftOrders";

export const useDraftDbsBaskets = ({
  includeStorefrontDrafts = true,
}: { includeStorefrontDrafts?: boolean } = {}) => {
  const { orders: draftOrders } = useDraftOrders();
  const basketsQuery = useUnifiedCheckoutBasketList();
  const { orders: dbsDraftOrders, isLoading: productsLoading } =
    useUnifiedCheckoutDraftOrders(basketsQuery.data);

  const storefrontDraftOrders = includeStorefrontDrafts
    ? (draftOrders ?? [])
    : [];

  const allSupplierIds = [...dbsDraftOrders, ...(storefrontDraftOrders ?? [])]
    .map((order) => order.SupplierId)
    .filter((id): id is number => id != null);

  const draftOrderListQuery = useDraftOrderList(
    {
      query: [
        {
          type: "supplierIdList",
          modifier: "IN",
          value: allSupplierIds,
        },
      ],
      limit: 20,
    },
    {
      enabled: allSupplierIds.length > 0,
    },
  );

  const totalBasketCount = dbsDraftOrders.length;

  const totalItemCount = dbsDraftOrders.reduce(
    (acc, order) =>
      acc +
      (order.OrderItems?.reduce(
        (itemAcc, item) => itemAcc + item.quantity,
        0,
      ) ?? 0),
    0,
  );

  return {
    dbsDraftOrders,
    storefrontDraftOrders,
    draftOrderListQuery,
    totalBasketCount,
    totalItemCount,
    baskets: basketsQuery.data ?? [],
    isLoading: basketsQuery.isLoading || productsLoading,
  };
};
